export default {
  EXPAND_ON_CLICK: 1,
  ALWAYS_SHOW: 2,
  NEVER_SHOW: 3,
};



// WEBPACK FOOTER //
// ./src/default-settings/channel-video-list-values.js